export const SEAT_SUITABLE_FOR_UNUSAL_NEEDS = {
    SUITABLE_FOR_ADULT_WITH_INFANT: 'seat_suitable_for_adult_with_infant',
    SEAT_WITH_BASSINET_FACILITY: 'seat_with_bassinet_facility',
    SEAT_SUITABLE_FOR_UNACCOMPANIED_MINORS: 'seat_suitable_for_unaccompanied_minors',
    FACILITIES_FOR_DISABLED_PASSENGER: 'seat_with_facilities_for_handicapped_or_incapacitated_passenger',
};

export const SEAT_SUITABLE_FOR_UNUSAL_NEEDS_LIST = [
    SEAT_SUITABLE_FOR_UNUSAL_NEEDS.SUITABLE_FOR_ADULT_WITH_INFANT,
    SEAT_SUITABLE_FOR_UNUSAL_NEEDS.SEAT_WITH_BASSINET_FACILITY,
    SEAT_SUITABLE_FOR_UNUSAL_NEEDS.SEAT_SUITABLE_FOR_UNACCOMPANIED_MINORS,
    SEAT_SUITABLE_FOR_UNUSAL_NEEDS.FACILITIES_FOR_DISABLED_PASSENGER,
];

export const SEAT_SUITABLE_FOR_UNUSAL_NEEDS_LABEL = {
    [SEAT_SUITABLE_FOR_UNUSAL_NEEDS.SUITABLE_FOR_ADULT_WITH_INFANT]: 'seat suitable for adult with infant',
    [SEAT_SUITABLE_FOR_UNUSAL_NEEDS.SEAT_WITH_BASSINET_FACILITY]: 'seat with bassinet facility',
    [SEAT_SUITABLE_FOR_UNUSAL_NEEDS.SEAT_SUITABLE_FOR_UNACCOMPANIED_MINORS]: 'seat suitable for unaccompanied minors',
    [SEAT_SUITABLE_FOR_UNUSAL_NEEDS.FACILITIES_FOR_DISABLED_PASSENGER]: 'seat with facilities for handicapped or incapacitated passenger',
};

export const SEAT_SPECIFIC_RESTRICTED = {
    SEAT_NOT_ALLOWED_FOR_INFANT: 'seat_not_allowed_for_infant',
    SEAT_TO_BE_LEFT_VACANT_OR_OFFERED_LAST: 'seat_to_be_left_vacant_or_offered_last',
    SEAT_NOT_ALLOWED_FOR_UNACCOMPANIED_MINOR: 'seat_not_allowed_for_unaccompanied_minor',
    DEPORTEE: 'deportee',
    CREW_SEAT: 'crew_seat',
};

export const SEAT_ENTERTAINMENT = {
    SEAT_WITH_MOVIE_VIEW: 'seat_with_movie_view',
    INDIVIDUAL_MOVIE_SCREEN_WITH_CHOICE_OF_MOVIES: 'individual_movie_screen_with_choice_of_movies',
    INDIVIDUAL_MOVIE_SCREEN_WITHOUT_CHOICE_OF_MOVIES: 'individual_movie_screen_without_choice_of_movies',
    INDIVIDUAL_SCREEN_WITH_MOVIES_GAMES_INFORMATION: 'individual_movie_screen_with_choice_of_movies_games_information_etc',
    BULKHEAD_SEAT_WITH_MOVIE_SCREEN: 'bulkhead_seat_with_movie_screen',
    INDIVIDUAL_MOVIE_SCREEN_WITHOUT_CHOICE: 'individual_movie_screen_without_choice',
    ELECTRONIC_CONNECTION_FOR_LAPTOP_OR_FAX: 'electronic_connection_for_laptop_or_fax',
    SEAT_WITHOUT_A_MOVIE_VIEW: 'seat_without_a_movie_view',
    INDIVIDUAL_AIRPHONE: 'individual_airphone',
};

export const SEAT_ENTERTAINMENT_LIST = [
    SEAT_ENTERTAINMENT.SEAT_WITH_MOVIE_VIEW,
    SEAT_ENTERTAINMENT.INDIVIDUAL_MOVIE_SCREEN_WITH_CHOICE_OF_MOVIES,
    SEAT_ENTERTAINMENT.INDIVIDUAL_MOVIE_SCREEN_WITHOUT_CHOICE_OF_MOVIES,
    SEAT_ENTERTAINMENT.INDIVIDUAL_SCREEN_WITH_MOVIES_GAMES_INFORMATION,
    SEAT_ENTERTAINMENT.BULKHEAD_SEAT_WITH_MOVIE_SCREEN,
    SEAT_ENTERTAINMENT.INDIVIDUAL_MOVIE_SCREEN_WITHOUT_CHOICE,
    SEAT_ENTERTAINMENT.ELECTRONIC_CONNECTION_FOR_LAPTOP_OR_FAX,
    SEAT_ENTERTAINMENT.SEAT_WITHOUT_A_MOVIE_VIEW,
    SEAT_ENTERTAINMENT.INDIVIDUAL_AIRPHONE,
];

export const SEAT_POSSIBLY_UNAVAILABLE = {
    PREFERENTIAL_SEAT: 'preferential_seat',
};

export const SEAT_ENTERTAINMENT_LABEL = {
    [SEAT_ENTERTAINMENT.SEAT_WITH_MOVIE_VIEW]: 'seat with movie view',
    [SEAT_ENTERTAINMENT.INDIVIDUAL_MOVIE_SCREEN_WITH_CHOICE_OF_MOVIES]: 'individual movie screen with choice of movies',
    [SEAT_ENTERTAINMENT.INDIVIDUAL_MOVIE_SCREEN_WITHOUT_CHOICE_OF_MOVIES]: 'individual movie screen without choice of movies',
    [SEAT_ENTERTAINMENT.INDIVIDUAL_SCREEN_WITH_MOVIES_GAMES_INFORMATION]: 'individual movie screen with choice of movies games information etc',
    [SEAT_ENTERTAINMENT.BULKHEAD_SEAT_WITH_MOVIE_SCREEN]: 'bulkhead seat with movie screen',
    [SEAT_ENTERTAINMENT.INDIVIDUAL_MOVIE_SCREEN_WITHOUT_CHOICE]: 'individual movie screen without choice',
    [SEAT_ENTERTAINMENT.ELECTRONIC_CONNECTION_FOR_LAPTOP_OR_FAX]: 'electronic connection for laptop or fax',
    [SEAT_ENTERTAINMENT.SEAT_WITHOUT_A_MOVIE_VIEW]: 'seat without a movie view',
    [SEAT_ENTERTAINMENT.INDIVIDUAL_AIRPHONE]: 'individual airphone',
};

export const SEAT_SURROUNDING = {
    WINDOWSEAT_WITHOUT_WINDOW: 'windowseat_without_window',
    NOT_A_WINDOW_SEAT: 'not_a_window_seat',
    NOT_AN_AISLE_SEAT: 'not_an_aisle_seat',
    NEAR_GALLEY_SEAT: 'near_galley_seat',
    IN_FRONT_OF_GALLEY_SEAT: 'in_front_of_galley_seat',
    BEHIND_GALLEY_SEAT: 'behind_galley_seat',
    NEAR_TOILET_SEAT: 'near_toilet_seat',
    IN_FRONT_OF_TOILET_SEAT: 'in_front_of_toilet_seat',
    BEHIND_TOILET_SEAT: 'behind_toilet_seat',
    ADJACENT_TO_GALLEY: 'adjacent_to_galley',
    ADJACENT_AISLE_SEATS: 'adjacent_aisle_seats',
    ADJACENT_TO_LAVATORY: 'adjacent_to_lavatory',
    ADJACENT_TO_BAR: 'adjacent_to_bar',
    ADJACENT_TO_CLOSET: 'adjacent_to_closet',
    SEAT_ADJACENT_TO_TABLE: 'seat_adjacent_to_table',
    SEAT_ADJACENT_TO_STAIRS_TO_UPPER_DECK: 'seat_adjacent_to_stairs_to_upper_deck',
};

export const SEAT_SURROUNDING_LIST = [
    SEAT_SURROUNDING.WINDOWSEAT_WITHOUT_WINDOW,
    SEAT_SURROUNDING.NOT_A_WINDOW_SEAT,
    SEAT_SURROUNDING.NOT_AN_AISLE_SEAT,
    SEAT_SURROUNDING.NEAR_GALLEY_SEAT,
    SEAT_SURROUNDING.IN_FRONT_OF_GALLEY_SEAT,
    SEAT_SURROUNDING.BEHIND_GALLEY_SEAT,
    SEAT_SURROUNDING.NEAR_TOILET_SEAT,
    SEAT_SURROUNDING.IN_FRONT_OF_TOILET_SEAT,
    SEAT_SURROUNDING.BEHIND_TOILET_SEAT,
    SEAT_SURROUNDING.ADJACENT_TO_GALLEY,
    SEAT_SURROUNDING.ADJACENT_AISLE_SEATS,
    SEAT_SURROUNDING.ADJACENT_TO_LAVATORY,
    SEAT_SURROUNDING.ADJACENT_TO_BAR,
    SEAT_SURROUNDING.ADJACENT_TO_CLOSET,
    SEAT_SURROUNDING.SEAT_ADJACENT_TO_TABLE,
    SEAT_SURROUNDING.SEAT_ADJACENT_TO_STAIRS_TO_UPPER_DECK,
];

export const SEAT_SURROUNDING_LABEL = {
    [SEAT_SURROUNDING.WINDOWSEAT_WITHOUT_WINDOW]: 'window-seat without window',
    [SEAT_SURROUNDING.NOT_A_WINDOW_SEAT]: 'not a window seat',
    [SEAT_SURROUNDING.NOT_AN_AISLE_SEAT]: 'not an aisle seat',
    [SEAT_SURROUNDING.NEAR_GALLEY_SEAT]: 'near galley seat',
    [SEAT_SURROUNDING.IN_FRONT_OF_GALLEY_SEAT]: 'in front of galley seat',
    [SEAT_SURROUNDING.BEHIND_GALLEY_SEAT]: 'behind galley seat',
    [SEAT_SURROUNDING.NEAR_TOILET_SEAT]: 'near toilet seat',
    [SEAT_SURROUNDING.IN_FRONT_OF_TOILET_SEAT]: 'in front of toilet seat',
    [SEAT_SURROUNDING.BEHIND_TOILET_SEAT]: 'behind toilet seat',
    [SEAT_SURROUNDING.ADJACENT_TO_GALLEY]: 'adjacent to galley',
    [SEAT_SURROUNDING.ADJACENT_AISLE_SEATS]: 'adjacent aisle seats',
    [SEAT_SURROUNDING.ADJACENT_TO_LAVATORY]: 'adjacent to lavatory',
    [SEAT_SURROUNDING.ADJACENT_TO_BAR]: 'adjacent to bar',
    [SEAT_SURROUNDING.ADJACENT_TO_CLOSET]: 'adjacent to closet',
    [SEAT_SURROUNDING.SEAT_ADJACENT_TO_TABLE]: 'seat adjacent to table',
    [SEAT_SURROUNDING.SEAT_ADJACENT_TO_STAIRS_TO_UPPER_DECK]: 'seat adjacent to stairs to upper deck',
};

export const SEAT_GENERAL_RESTRICTED = {
    RESTRICTED_GENERAL: 'restricted_general',
    RESTRICTED_RECLINE_SEAT: 'restricted_recline_seat',
    RESTRICTED_SEAT_OFFERED_ON_LONG_HAUL_SEGMENTS: 'restricted_seat_offered_on_long_haul_segments',
};

export const SEAT_GENERAL_RESTRICTED_LIST = [
    SEAT_GENERAL_RESTRICTED.RESTRICTED_GENERAL,
    SEAT_GENERAL_RESTRICTED.RESTRICTED_RECLINE_SEAT,
    SEAT_GENERAL_RESTRICTED.RESTRICTED_SEAT_OFFERED_ON_LONG_HAUL_SEGMENTS,
];

export const SEAT_POSITION = {
    CENTER_SEAT: 'center_seat',
    AISLE_SEAT: 'aisle_seat',
    WINDOW_SEAT: 'window_seat',
    ALL_AVAILABLE_AISLE_SEATS: 'all_available_aisle_seats',
    ADDED_SEAT: 'added_seat',
    FRONT_OF_CABIN_CLASS_OR_COMPARTMENT: 'front_of_cabin_class_or_compartment',
    SEAT_AT_FORWARD_END_OF_CABIN: 'seat_at_forward_end_of_cabin',
    INSIDE_AISLE_SEAT: 'inside_aisle_seat',
    REAR_FACING_SEAT: 'rear_facing_seat',
    LEFT_SIDE_OF_AIRCRAFT: 'left_side_of_aircraft',
    CENTER_SECTION_SEAT: 'center_section_seat',
    RIGHT_SIDE_OF_AIRCRAFT: 'right_side_of_aircraft',
    BULKHEAD_SEAT: 'bulkhead_seat',
    EXIT_ROW_SEAT: 'exit_row_seat',
    NOT_AN_EXIT_SEAT: 'not_an_exit_seat',
    REAR_TAIL_SECTION_OF_AIRCRAFT: 'rear_tail_section_of_aircraft',
    UPPER_DECK: 'uppper_deck',
    WINDOW_AND_AISLE_TOGETHER: 'window_and_aisle_together',
    OVERWING_SEAT: 'overwing_seat',
};

export const SEAT_POSITION_LIST = [
    SEAT_POSITION.CENTER_SEAT,
    SEAT_POSITION.AISLE_SEAT,
    SEAT_POSITION.WINDOW_SEAT,
    SEAT_POSITION.ALL_AVAILABLE_AISLE_SEATS,
    SEAT_POSITION.ADDED_SEAT,
    SEAT_POSITION.FRONT_OF_CABIN_CLASS_OR_COMPARTMENT,
    SEAT_POSITION.SEAT_AT_FORWARD_END_OF_CABIN,
    SEAT_POSITION.INSIDE_AISLE_SEAT,
    SEAT_POSITION.REAR_FACING_SEAT,
    SEAT_POSITION.LEFT_SIDE_OF_AIRCRAFT,
    SEAT_POSITION.CENTER_SECTION_SEAT,
    SEAT_POSITION.RIGHT_SIDE_OF_AIRCRAFT,
    SEAT_POSITION.BULKHEAD_SEAT,
    SEAT_POSITION.EXIT_ROW_SEAT,
    SEAT_POSITION.NOT_AN_EXIT_SEAT,
    SEAT_POSITION.REAR_TAIL_SECTION_OF_AIRCRAFT,
    SEAT_POSITION.UPPER_DECK,
    SEAT_POSITION.WINDOW_AND_AISLE_TOGETHER,
    SEAT_POSITION.OVERWING_SEAT,
];

export const SEAT_POSITION_LABEL = {
    [SEAT_POSITION.CENTER_SEAT]: 'center seat',
    [SEAT_POSITION.AISLE_SEAT]: 'aisle seat',
    [SEAT_POSITION.WINDOW_SEAT]: 'window seat',
    [SEAT_POSITION.ALL_AVAILABLE_AISLE_SEATS]: 'all available aisle seats',
    [SEAT_POSITION.ADDED_SEAT]: 'added seat',
    [SEAT_POSITION.FRONT_OF_CABIN_CLASS_OR_COMPARTMENT]: 'front of cabin class or compartment',
    [SEAT_POSITION.SEAT_AT_FORWARD_END_OF_CABIN]: 'seat at forward end of cabin',
    [SEAT_POSITION.INSIDE_AISLE_SEAT]: 'inside aisle seat',
    [SEAT_POSITION.REAR_FACING_SEAT]: 'rear facing seat',
    [SEAT_POSITION.LEFT_SIDE_OF_AIRCRAFT]: 'left side of aircraft',
    [SEAT_POSITION.CENTER_SECTION_SEAT]: 'center section seat',
    [SEAT_POSITION.RIGHT_SIDE_OF_AIRCRAFT]: 'right side of aircraft',
    [SEAT_POSITION.BULKHEAD_SEAT]: 'bulkhead seat',
    [SEAT_POSITION.EXIT_ROW_SEAT]: 'exit row seat',
    [SEAT_POSITION.NOT_AN_EXIT_SEAT]: 'not an exit seat',
    [SEAT_POSITION.REAR_TAIL_SECTION_OF_AIRCRAFT]: 'rear tail section of aircraft',
    [SEAT_POSITION.UPPER_DECK]: 'upper deck',
    [SEAT_POSITION.WINDOW_AND_AISLE_TOGETHER]: 'window and aisle together',
    [SEAT_POSITION.OVERWING_SEAT]: 'overwing seat',
};

export const SEAT_CONVENIENCE = {
    LEG_REST_AVAILABLE: 'leg_rest_available',
    LEG_SPACE_SEAT: 'leg_space_seat',
    ECONOMY_COMFORT_SEAT: 'economy_comfort_seat',
    SEAT_IN_A_QUIET_ZONE: 'seat_in_a_quiet_zone',
    PREMIUM_SEAT: 'premium_seat',
};

export const SEAT_CONVENIENCE_LABEL = {
    [SEAT_CONVENIENCE.LEG_REST_AVAILABLE]: 'leg rest available',
    [SEAT_CONVENIENCE.LEG_SPACE_SEAT]: 'leg space seat',
    [SEAT_CONVENIENCE.ECONOMY_COMFORT_SEAT]: 'economy comfort seat',
    [SEAT_CONVENIENCE.SEAT_IN_A_QUIET_ZONE]: 'seat in a quiet zone',
    [SEAT_CONVENIENCE.PREMIUM_SEAT]: 'premium seat',
};

export const SEAT_CONVENIENCE_LIST = [
    SEAT_CONVENIENCE.LEG_REST_AVAILABLE,
    SEAT_CONVENIENCE.LEG_SPACE_SEAT,
    SEAT_CONVENIENCE.ECONOMY_COMFORT_SEAT,
    SEAT_CONVENIENCE.SEAT_IN_A_QUIET_ZONE,
    SEAT_CONVENIENCE.PREMIUM_SEAT,
];



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-seatmap/amadeus-seatmap/amadeus-seat-enum.js